<template>
    <div class="ppv2-p-6">
        <Header :title="$t('roles.title')" />
        <RolesTable :token="token" />
    </div>
</template>

<script>
import RolesTable from './RolesTable.vue'
import Header from '../../Shared/Header.vue'
import normalizeSize from '../../../utils/normalizeSize'
import normalizeFontSize from '../../../utils/normalizeFontSize'

export default {
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    name: 'RolesIndex',
    components: {
        RolesTable,
        Header,
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>

<style scoped lang="scss"></style>
